module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    ref: "container",
    attrs: {
      "id": "game-container"
    }
  }), _c('router-view'), _c('desktop'), _c('web-gl'), (_vm.debug) ? _c('debug') : _vm._e(), _c('div', {
    staticClass: "fonts"
  }, [_c('p', {
    staticClass: "tradegothic"
  }, [_vm._v("abcdefghijklmnopqrstuvwxyz")]), _c('p', {
    staticClass: "digital"
  }, [_vm._v("0123456789")]), _c('p', {
    staticClass: "cjnbold"
  }, [_vm._v(_vm._s(_vm.flatMessages))]), _c('p', {
    staticClass: "fos"
  }, [_vm._v(_vm._s(_vm.flatMessages) + "PEGASUS")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 609
// module chunks = 1